import React, { useState, useEffect } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";
import DropZone from "../../component/dropzone/DropZone";
import MediaPopup from "../../component/mediapopup/MediaPopup";

const AddTeacher = () => {
  const token = config.token;
  const { id, aprvl } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // ------------------------------------- Input Field state management -------------------------------

  // const [iconFileValue, setIconFileValue] = useState();
  const [imageLinkValue, setImageLinkValue] = useState("");

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    mobileno: "",
    address: "",
    image: "",
    gender: "",
    dob: "",
    isTPT: false,
    incentive: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleTPTBtn = () => {
    setFormData((prevData) => ({
      ...prevData,
      isTPT: !prevData.isTPT,
    }));
  };
  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setImageLinkValue("");
    setFormData({
      fname: "",
      lname: "",
      email: "",
      mobileno: "",
      address: "",
      image: "",
      gender: "",
      dob: "",
      isTPT: false,
      incentive: "",
    });

    if (id) {
      aprvl ? navigate("/tcrforaprvl") : navigate("/viewteachers");
    }
  };

  // --------------------------------------- submit form -----------------------------------C--U
  const handleCreateTeacher = async (e) => {
    e.preventDefault();

    // Update the image value in the formData state
    const updatedFormData = {
      ...formData,
      image: imageLinkValue,
      isTPT: formData.isTPT ? "1" : "0",
    };

    // --- Require field validation ---
    if (
      !updatedFormData.fname.trim() ||
      !updatedFormData.lname.trim() ||
      !updatedFormData.email.trim() ||
      updatedFormData.mobileno === "" ||
      !updatedFormData.address.trim() ||
      updatedFormData.image === "" ||
      updatedFormData.image === null ||
      (updatedFormData.isTPT === "1" &&
        (updatedFormData.incentive === "" ||
          updatedFormData.incentive === null ||
          updatedFormData.incentive === undefined))
    ) {
      triggerNotification("error", "Input fields cannot be empty!!");
      return; // Stop form submission
    } else if (!updatedFormData.gender.trim() || !updatedFormData.dob.trim()) {
      triggerNotification("error", "Please select date and gender!!");
      return; // Stop form submission
    }

    // --- Email validation ---
    const validateEmail = (email) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailRegex.test(email);
    };

    if (!validateEmail(updatedFormData.email)) {
      triggerNotification("error", "Please enter a valid email address");
      return; // Stop form submission
    }

    // Convert updatedFormData to FormData
    const formDataObject = new FormData();
    for (const key in updatedFormData) {
      formDataObject.append(key, updatedFormData[key]);
    }

    // Call the API to create a teacher with formDataObject
    try {
      if (!token) {
        triggerNotification("error", "Please login to create a teacher");
        return;
      }

      await fetch(
        `${config.host_url}teacher/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: id ? "PUT" : "POST",
          headers: {
            // "Content-Type": "application/json", // FormData automatically sets the correct Content-Type
            token: token,
          },
          body: formDataObject,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              `Teacher ${id ? "updated" : "created"} successfully.`
            );
            setFormData({
              fname: "",
              lname: "",
              email: "",
              mobileno: "",
              address: "",
              image: "",
              gender: "",
              dob: "",
              isTPT: false,
              incentive: "",
            });
            setImageLinkValue("");
            aprvl ? navigate("/tcrforaprvl") : navigate("/viewteachers");
          } else if (data.status === 400) {
            // Handle validation errors if any
            const errorMsgs = Array.isArray(data.msg)
              ? data.msg.join(", ")
              : data.msg;
            console.log("Error: ", errorMsgs);
            triggerNotification(
              "error",
              errorMsgs
                ? errorMsgs
                : "Some Error Occur!! Please Login After Some Time"
            );
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated user!");
          } else {
            triggerNotification("error", "Internal Server Error");
          }
        });
    } catch (error) {
      triggerNotification(
        "error",
        "Some Error Occurred!! Please try again later"
      );
    }
  };

  // --------------------------------------- set data for Edit form -----------------------------------
  const updateFieldValueSet = async (id) => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}teacher/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            const responseData = data.data;
            const serverDate = await new Date(responseData.dob);
            const formattedDate = serverDate.toISOString().split("T")[0];

            await setFormData({
              fname: responseData.fname,
              lname: responseData.lname,
              email: responseData.email,
              mobileno: responseData.mobileno,
              address: responseData.address,
              image: responseData.image,
              gender: responseData.gender,
              dob: formattedDate,
              // isTPT: responseData.incentive !== null ? true : false,
              isTPT: responseData.isTPT === 1 ? true : false,
              incentive:
                responseData.incentive !== null
                  ? responseData.incentive
                  : undefined,
            });
            await setImageLinkValue(responseData.image);
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      updateFieldValueSet(id);
    }
  }, [id]);

  return (
    <>
      <Breadcrumb txt="Manage Teacher" subpath={["Add Teacher"]} />
      {!id && <DropZone url="teacher/excel" navigate="viewteachers" />}

      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Teacher</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-md-6">
                    {/* Teacher fname */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="fname"
                        id="fname"
                        placeholder="First Name"
                        value={formData.fname}
                        onChange={handleChange}
                      />
                      <label htmlFor="fname"> First Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {/* Teacher lname */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="lname"
                        id="lname"
                        placeholder="Last Name"
                        value={formData.lname}
                        onChange={handleChange}
                      />
                      <label htmlFor="lname">Last Name</label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    {/* Mobile Number */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="number"
                        className="form-control"
                        name="mobileno"
                        id="mobileno"
                        placeholder="Mobile Number"
                        value={formData.mobileno}
                        onChange={handleChange}
                      />
                      <label htmlFor="mobileno">Mobile Number</label>
                    </div>
                  </div>
                  {/* Email */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <label htmlFor="email">Email</label>
                    </div>
                  </div>
                </div>
                {/* Address */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    id="address"
                    placeholder="Address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                  <label htmlFor="address">Address</label>
                </div>
                {/* Teacher Image */}
                <MediaPopup
                  ttl="Image"
                  linkValue={imageLinkValue}
                  setLinkValue={setImageLinkValue}
                  // setFileValue={setIconFileValue}
                  mediaType="images"
                />
                {/* gender & dob */}
                <div className="row">
                  <div className="col-md-6">
                    {/* Gender */}
                    <div className="form-floating form-floating-outline mb-4">
                      <select
                        className="form-select"
                        name="gender"
                        id="gender"
                        aria-label="Select Gender"
                        value={formData.gender}
                        onChange={handleChange}
                      >
                        <option value="" disabled selected>
                          Select Gender
                        </option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                      <label htmlFor="gender">Gender</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {/* Date Of Birth */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="date"
                        className="form-control"
                        name="dob"
                        id="dob"
                        placeholder="Date Of Birth"
                        value={formData.dob}
                        onChange={handleChange}
                      />
                      <label htmlFor="dob">Date Of Birth</label>
                    </div>
                  </div>
                </div>

                {/* third party techer | incentive */}
                <div className="row">
                  {/* third party techer */}
                  <div className="col-sm-3 my-auto">
                    <div className="">
                      <div
                        className="mb-4  px-3 select-none"
                        onClick={handleTPTBtn}
                      >
                        {formData.isTPT ? (
                          <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                        ) : (
                          <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                        )}
                        <span>Third Party Teacher</span>
                        <span
                          style={{
                            visibility: formData.isTPT ? "hidden" : "visible",
                          }}
                        >
                          ?
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* incentive */}
                  {formData.isTPT && (
                    <div className="col-sm-9 ">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          className="form-control"
                          name="incentive"
                          id="incentive"
                          placeholder="Incentive"
                          value={formData.incentive}
                          onChange={handleChange}
                        />
                        <label htmlFor="incentive"> Incentive</label>
                      </div>
                    </div>
                  )}
                </div>

                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleCreateTeacher}
                    >
                      Submit
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddTeacher;
